import { Tag } from '@cian/components';
import * as React from 'react';

import { TagNew } from '../TagNew';

import { tagThemeSmall } from '../tag_theme';

export interface IWithLayoutTagItemProps {
  withNewTag?: boolean;
  onDeleteClick(): void;
}

export const WithLayoutTagItem = (props: IWithLayoutTagItemProps) => {
  const TagComponent = React.useMemo(() => (props.withNewTag ? TagNew : Tag), [props.withNewTag]);

  return (
    <TagComponent onDeleteClick={props.onDeleteClick} tagStyles={tagThemeSmall}>
      Со схемой планировки
    </TagComponent>
  );
};
